/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Ares_ErrorInputs */

const cs_property_registry_ares_error = /** @type {(inputs: Property_Registry_Ares_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dotaz do ARES selhal.`)
};

const en_property_registry_ares_error = /** @type {(inputs: Property_Registry_Ares_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARES lookup failed.`)
};

/**
* | output |
* | --- |
* | "ARES lookup failed." |
*
* @param {Property_Registry_Ares_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_ares_error = /** @type {((inputs?: Property_Registry_Ares_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Ares_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_ares_error(inputs)
	return cs_property_registry_ares_error(inputs)
});